module.exports = __webpack_public_path__ + "images/application/radar-map@2x-f2d0d0bb.png";